import { render, staticRenderFns } from "./editKlArticle.vue?vue&type=template&id=f56bc57e&scoped=true"
import script from "./editKlArticle.vue?vue&type=script&lang=js"
export * from "./editKlArticle.vue?vue&type=script&lang=js"
import style0 from "./editKlArticle.vue?vue&type=style&index=0&id=f56bc57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56bc57e",
  null
  
)

export default component.exports